import React, { FC, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

// hooks
import useOnMount from 'hooks/useOnMount';

// types
import { Option } from './MultipageDropdown';

interface LiProps {
  isDisabled: boolean;
  isSelected: boolean;
}

const Li = styled.li<LiProps>`
  ${({ isDisabled, isSelected, theme }) => `
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    padding: 0.15em 0.8em;
    font-size: 0.9em;
    list-style-type: none;

    ${
      isSelected
        ? `
          color: ${Colors.white};
          background-color: ${theme.palette.primary.main};`
        : ''
    }

    ${
      isDisabled
        ? `color: ${theme.palette.text.disabled};`
        : `
          color: ${theme.palette.text.main};

          ${isSelected ? `background-color: #74d3f5;` : ''}

          :hover {
            color: ${Colors.white};
            background-color: ${theme.palette.primary.main};
          }
        `
    };
  `}
`;

interface Props {
  option: Option;
  isSelected?: boolean;
  onSelect: (option: Option) => void;
  children: string;
}

const ListItem: FC<Props> = ({ option, isSelected = false, onSelect, children: label }) => {
  const selfRef = useRef<HTMLLIElement>(null);

  const { isDisabled = false } = option;

  useOnMount(() => {
    if (isSelected) {
      const { current: selfElement } = selfRef;

      if (selfElement) {
        selfElement.scrollIntoView();
      }
    }
  });

  const clickHandler = useCallback(() => {
    if (!isDisabled) {
      onSelect(option);
    }
  }, [isDisabled, option, onSelect]);

  return (
    <Li ref={selfRef} isDisabled={isDisabled} isSelected={isSelected} onClick={clickHandler}>
      {label}
    </Li>
  );
};

export default ListItem;
